import { action, observable, runInAction } from 'mobx';

import { Logger, NOOP_LOGGER } from 'bernie-logger';
import { SerializedData, Store } from 'bernie-core';

// did this ever work?
export class CheckoutStore extends Store {
  @observable
  public trip: any;

  constructor(private tripDetailsSource: any, state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
    this.tripDetailsSource = tripDetailsSource;
  }

  public hydrate(data: SerializedData): void {
    delete data.tripDetailsSource;
    Object.assign(this, data);
  }

  @action
  public fetchTrip(context, criteria, hotelId): any {
    this.trip = this.tripDetailsSource
      .fetch({ context, criteria, hotelId })
      .then(data => {
        runInAction('update trip details from response', () => {
          this.trip = data;
        });
      })
      .catch(() => {
        runInAction('recovering from trip details call breakdown', () => {
          // TODO: add failure logging and action
        });
      });

    return this.trip;
  }

  @action
  public fetchTripIfNecessary(context, criteria, hotelId): any {
    if (!this.trip) {
      return this.fetchTrip(context, criteria, hotelId);
    }
  }
}
